import React from "react";

const STEPS = [
  {
    num: "01",
    label: "Step 1",
    title: "Understand",
    text: "1st you need to purchase packages / hire marketer",
  },
  {
    num: "02",
    label: "Step 2",
    title: "Promote",
    text: "Marketing agent will approach your business to understand your business",
  },
  {
    num: "03",
    label: "Step 3",
    title: "Connect",
    text: "As per selected premium  marketing agent will start working",
    active: true,
  },
  {
    num: "04",
    label: "Step 4",
    title: "Follow",
    text: "You can see the statistics / progress of your marketing agent",
  },
  {
    num: "05",
    label: "Step 5",
    title: "Improve",
    text: "As per premium marketing agent will complete work in required time frame",
  },
];

export default function HowItWorks() {
  return (
    <section className="section-py section-soft" id="how-it-works">
      <div className="container-selectezi">
        <div className="section-head">
          <span className="eyebrow-label">Workflow Architecture</span>
          <h2 className="section-title">How It Works</h2>
          <p className="section-subtitle mx-auto">
            An ongoing structured methodology from initial profiling to
            adaptive optimization
          </p>
        </div>

        <div className="row g-4">
          {STEPS.map((step) => (
            <div className="col-6 col-lg" key={step.num}>
              <div className="step-card">
                <div className={`step-number-circle${step.active ? " is-active" : ""}`}>
                  {step.num}
                </div>
                <div className="step-label">{step.label}</div>
                {/* <div className="step-title">{step.title}</div> */}
                <p className="step-text">{step.text}</p>
                <span className="step-connector" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
